export default __webpack_public_path__ + "static/media/icon-config.1ec65134.svg";